import * as React from 'react';
import { Employee } from '../../../hooks/useEmployeeData';
import { personalakteStyles as ps, colors, shadows } from '../styles/personalakteStyles';

interface FinalizeEmployeeModalProps {
  open: boolean;
  employee: Employee | null;
  onClose: () => void;
  onConfirm: () => void;
  computeWorkAreas: (emp: Employee) => string;
  computeWeeklyHours: (emp: Employee) => string;
}

const modalOverlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.4)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalContentStyle: React.CSSProperties = {
  background: colors.bgCard,
  padding: '24px',
  borderRadius: '16px',
  width: '500px',
  boxShadow: shadows.elevated,
};

function FinalizeEmployeeModal({ open, employee, onClose, onConfirm, computeWorkAreas, computeWeeklyHours }: FinalizeEmployeeModalProps) {
  if (!open || !employee) return null;

  return (
    <div style={modalOverlayStyle} onClick={onClose}>
      <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3 style={{ margin: 0, color: colors.navy, fontSize: 16, fontWeight: 700 }}>Finalize Employee Onboarding</h3>
          <button
            onClick={onClose}
            style={{
              background: colors.bgMuted,
              border: 'none',
              fontSize: '16px',
              cursor: 'pointer',
              color: colors.textMuted,
              padding: '0',
              width: '28px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              transition: 'background 0.15s',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = colors.bgHover; }}
            onMouseLeave={e => { e.currentTarget.style.background = colors.bgMuted; }}
            title="Close"
          >
            ×
          </button>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <h4>Employee Details</h4>
          <p><strong>Name:</strong> {employee.first_name} {employee.last_name}</p>
          <p><strong>Email:</strong> {employee.email}</p>
          <p><strong>Work Areas:</strong> {computeWorkAreas(employee)}</p>
          <p><strong>Working Hours:</strong> {computeWeeklyHours(employee)}</p>
          <p><strong>Documents:</strong></p>
          <div style={{ marginLeft: '20px' }}>
            <p>Red Card: {employee.infektionsschutz_document ? '✅' : '❌'}</p>
            <p>Imma: {employee.imma_document ? '✅' : '❌'}</p>
            <p>Contract: {employee.arbeitsvertrag_document ? '✅' : '❌'}</p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '16px' }}>
          <button
            className="hover-btn-secondary"
            onClick={onClose}
            style={ps.buttonSecondary}
          >
            Cancel
          </button>
          <button
            className="hover-btn-primary"
            onClick={onConfirm}
            style={ps.buttonPrimary}
          >
            Confirm & Activate
          </button>
        </div>
      </div>
    </div>
  );
}

export default FinalizeEmployeeModal;
